<template>
  <div>
    <v-snackbar class="notification-popup"
      v-model="snackbar"
      color="white"
      :timeout="notificationConfig.timeout"
      :top="notificationConfig.y === 'top'"
      :bottom="notificationConfig.y === 'bottom'"
      :left="notificationConfig.x === 'left'"
      :right="notificationConfig.x === 'right'"
      :multi-line="notificationConfig.mode === 'multi-line'"
      :vertical="notificationConfig.mode === 'vertical'">
      <v-alert
        v-model="alert"
        dismissible
        :color="notificationConfig.color"
        :border="'left'"
        elevation="2"
        colored-border
        :icon="notificationConfig.icon">
        {{ notificationConfig.message }}
        <template v-slot:close>
          <v-icon :color="notificationConfig.color" class="ml-8" @click="close">cancel</v-icon>
        </template>
      </v-alert>
    </v-snackbar>
  </div>
</template>

<script>
import { cloneObject } from '@/shared/clone'

export default {
  name: 'NotificationPopup',
  data () {
    return {
      snackbar: false,
      alert: true,
      defaultConfig: {
        color: 'cyan',
        mode: '',
        message: '',
        timeout: 60000,
        x: 'right',
        y: 'top',
        icon: 'info'
      },
      notificationConfig: {}
    }
  },
  methods: {
    show (notification) {
      this.notificationConfig = cloneObject(this.defaultConfig)

      for (const key in this.notificationConfig) {
        if (notification[key] !== undefined) {
          this.notificationConfig[key] = notification[key]
        }
      }

      this.snackbar = true
    },
    close () {
      this.snackbar = false
    }
  }
}
</script>

<style scoped>
.notification-popup >>> .v-snack__content {
  padding: 0px 0px;
  max-width: 520px;
}
.v-alert{
  margin-bottom: 0px;
  width: 100%;
}
</style>
